import { Fragment } from 'react';
import Footer from './Footer';
import Header from './Header';
import LeftBar from './LeftBar';


const LayoutUnAuthorized = (props) => {
  return (
    <Fragment>
       {props.children}
    </Fragment>
  );
};

export default LayoutUnAuthorized;

